import React, { useEffect, useContext } from 'react';
import { sentperairline, categorypicker, timeslider, sankey, entities, keyphrases, sentimentpercentage, tweettrend } from '../visualization/twitter-app';
import "./ChartContainer.css";
import Widget from './Widget';
import AppContext from './AppContext';

function ChartContainer() {

    const dataState = useContext(AppContext);

    useEffect(() => {
        timeslider()
            .element('tweets-time')
            .execute()
            .catch((err) => {
                console.log(`There was an error with widget tweets-time`)
                dataState.esError = true;
                dataState.setEsError(true);
                window.cf.getVisualization('tweets-time').get('visual').playing = false;
            });
    }, [])


    return (
        <div className="chart-container d-flex flex-column" >
            {dataState.esError && <a className="ES-error">Error: No Living connections. Contact the site administrator</a>}
            {!dataState.esError && <div id="tweets-time" className="tweets-time"></div>}
            <div className="d-flex flex-row flex-wrap flex-grow-1">
                <div className="col-12 col-lg-4">
                    <Widget
                        id="tweets-heatmap"
                        title="Categories"
                        flushToBottom={false}
                        style={{ width: '98%', height: 'calc(65% - 10px)' }}
                        viz={sankey}
                        showLoading={true}
                    />
                    <Widget
                        id="tweets-trend"
                        title="Tweet trend"
                        flushToBottom={false}
                        style={{ width: '98%', height: 'calc(35% - 10px)' }}
                        viz={tweettrend}
                        showLoading={true}
                    />


                </div>
                <div className="col-12 col-lg-4">

                    <Widget
                        id="tweets-sentiments"
                        title="Sentiments per Airline"
                        flushToBottom={false}
                        viz={sentperairline}
                        style={{ width: '98%', height: 'calc(50% - 10px)' }}
                        showLoading={true}
                    />
                    <Widget
                        id="tweets-sentimen-percentage"
                        title="Sentiment percent per  Airline"
                        flushToBottom={false}
                        viz={sentimentpercentage}
                        style={{ width: '98%', height: 'calc(50% - 10px)' }}
                        showLoading={true}
                    />
                </div>
                <div className="col-12 col-lg-4">
                    <Widget
                        id="tweets-categories"
                        title="Pick category"
                        viz={categorypicker}
                        showLoading={false}
                        style={{ width: '98%', height: 'calc(33.33% - 10px)' }}
                    />
                    <Widget
                        id="tweets-entities"
                        title="Top Entities"
                        viz={entities}
                        showLoading={false}
                        style={{ width: '98%', height: 'calc(33.33% - 10px)' }}
                    />
                    <Widget
                        id="tweets-phrases"
                        title="Top Phrases"
                        viz={keyphrases}
                        showLoading={false}
                        style={{ width: '98%', height: 'calc(33.33% - 10px)' }}
                    />
                </div>





            </div>

        </div>
    );
}

export default ChartContainer;